export default __webpack_public_path__ + "static/media/Vinidex 1.6 ratio.cf95544a.png";